import React from 'react';
import { Card, Badge, Col } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaBolt, FaFire, FaUser, FaBuilding, FaTimesCircle } from 'react-icons/fa';
import { subtipoLabels, getOfferStagePresentation } from '../../utils/ofertasUtils';

const tipoOferta = {
    simple: "CONTRATO NUEVO",
    renovacion: "RENOVACIÓN",
};

// Targeta individual del llistat d'ofertes; usada a OfertasList.
const OfferListCard = ({ oferta }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const clientName = oferta.cliente_nombre || oferta.cliente_apellidos
        ? `${oferta.cliente_nombre || ''} ${oferta.cliente_apellidos || ''}`.trim()
        : 'Cliente no asignado';

    const isElectric = oferta.sector_type === 'electrico';
    const sectorIcon = isElectric ? <FaBolt /> : <FaFire />;
    const sectorColor = isElectric ? 'var(--ab-primary-light)' : 'var(--ab-warning)';
    const stagePresentation = getOfferStagePresentation(oferta);

    return (
        <Col lg={4} md={6} className="mb-4">
            <Card
                className="h-100 border-0 shadow-sm hover-elevate transition-all rounded-4 overflow-hidden"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(`/contratos/ofertas/${oferta.id}${location.search}`)}
            >
                <Card.Body className="p-4 d-flex flex-column">
                    {/* Header: Sector Icon + ID + Date */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex align-items-center gap-2">
                            <div
                                className="d-flex align-items-center justify-content-center rounded-circle text-white"
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    fontSize: '1.2rem',
                                    background: sectorColor
                                }}
                            >
                                {sectorIcon}
                            </div>
                            <div>
                                <h6 className="fw-bold mb-0 text-brand">#{oferta.id}</h6>
                                <small className="text-muted" style={{ fontSize: '0.75rem' }}>{oferta.create_date}</small>
                            </div>
                        </div>
                        <Badge
                            pill
                            bg={stagePresentation.hasSignaturitError ? 'danger' : 'primary'}
                            style={{ fontSize: '0.75rem' }}
                            className="d-inline-flex align-items-center gap-1"
                        >
                            {stagePresentation.hasSignaturitError && <FaTimesCircle aria-hidden="true" />}
                            {stagePresentation.label}
                        </Badge>
                    </div>

                    {/* Content: Name + Type */}
                    <div className="mb-3">
                        <h5 className="fw-bold text-dark mb-1 text-truncate" title={clientName}>
                            {clientName}
                        </h5>
                        {oferta.cliente_vat && (
                            <div className="text-muted small mb-2">{oferta.cliente_vat}</div>
                        )}
                        <div className="d-flex gap-2 flex-wrap">
                            <Badge pill bg="light" className="text-dark border">
                                {tipoOferta[oferta.type] || oferta.type}
                            </Badge>
                            {oferta.sub_type_offer && (
                                <Badge pill bg="secondary" className="text-white border">
                                    {subtipoLabels[oferta.sub_type_offer] || oferta.sub_type_offer}
                                </Badge>
                            )}
                        </div>
                    </div>

                    {/* Footer: Client Info */}
                    <div className="mt-auto pt-3 border-top">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center gap-2 text-muted">
                                <FaUser size={14} />
                                <span className="small text-truncate" style={{ maxWidth: '150px' }}>
                                    {oferta.prescriptor || 'Sin agente'}
                                </span>
                            </div>
                            {oferta.cups_name && (
                                <div className="d-flex align-items-center gap-2 text-muted" title="CUPS">
                                    <FaBuilding size={14} />
                                    <span className="small">{oferta.cups_name}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default OfferListCard;
